import { makeAutoObservable } from "mobx";
import type { EpisodesApi, LatestParams } from "@/api/episodes";
import { PagedResource } from "./Resource";

/** The API pages episodes 30 at a time */
const EPISODES_PAGE_SIZE = 30;

/** The latest episodes, for a language and either all podcasts or the toplist ones. */
export class EpisodeStore {
    readonly feed: PagedResource<Episode, LatestParams>;

    constructor(private readonly api: EpisodesApi) {
        this.feed = new PagedResource((params, page) => this.api.latest(params, page), EPISODES_PAGE_SIZE);

        makeAutoObservable<EpisodeStore, "api">(this, { api: false, feed: false });
    }

    get latest(): Episode[] {
        return this.feed.items;
    }

    /** The first page is on its way */
    get loading() {
        return this.feed.loading && this.feed.items.length === 0;
    }

    /** A further page is on its way */
    get getting() {
        return this.feed.loading && this.feed.items.length > 0;
    }

    /** Loads the first page unless this language and filter is already loaded. Rejects when that fails. */
    async loadLatest(lang = "sv", onlyToplist = 1) {
        await this.feed.load({ lang, onlyToplist });
        if (this.feed.status === "error") {
            throw this.feed.error;
        }
    }

    loadMore() {
        return this.feed.loadMore();
    }
}
